/** When landscape main content is shorter than this, collapse text spacing for the pinyin keyboard. */
export const LANDSCAPE_COMPRESSED_CONTENT_MAX_HEIGHT = 280;
